// Play Battle entry: prompts the user to pick one of their owned
// Snordeluxes, then opens the multiplayer lobby browser so the user
// can join an existing match or host a new one.

import { snordeluxeAssets } from '../snordeluxeAssets';
import { getUser } from './views';
import { showLobbyBrowser } from './lobbyBrowser';

function closeModal() {
    const m = document.getElementById('snordeluxeSelectModal');
    if (m) m.style.display = 'none';
}

export function showSnordeluxeSelectModal() {
    const modal = document.getElementById('snordeluxeSelectModal');
    const grid = document.getElementById('snordeluxeSelectGrid');
    if (!modal || !grid) return;

    const user = getUser();
    const inventory = (user && user.inventory) || [];

    grid.innerHTML = '';
    if (!inventory.length) {
        grid.innerHTML = '<p class="snordeluxe-select-empty">No Snordeluxes yet — visit the Shop to buy one.</p>';
    } else {
        inventory.forEach(snordeluxe => {
            const details = snordeluxeAssets[snordeluxe.name];
            if (!details) return;
            const card = document.createElement('button');
            card.type = 'button';
            card.className = 'snordeluxe-select-card';
            card.innerHTML = `
                <img src="${details.image}" alt="${snordeluxe.name}" />
                <span class="snordeluxe-select-name">${snordeluxe.name}</span>
                <span class="snordeluxe-select-meta">HP ${details.hitpoints}</span>
            `;
            card.addEventListener('click', () => {
                closeModal();
                showLobbyBrowser(snordeluxe.name);
            });
            grid.appendChild(card);
        });
    }
    modal.style.display = 'flex';

    const closeBtn = document.getElementById('snordeluxeSelectClose');
    if (closeBtn) closeBtn.onclick = closeModal;
    modal.onclick = (e) => { if (e.target === modal) closeModal(); };
}
